<template>
  <div class="Sound" :class="{ 'is-active': active }" @click="active = !active">
    <div class="Sound__ico" v-html="require('./svg/ico.svg')" />
  </div>
</template>
<script>
import {Howl, Howler} from 'howler'
import spriteJSON from './audio/sound_2.json'
import ambianceJSON from './audio/ambiance.json'
import Cookies from 'js-cookie'
import Settings from '@/config/Settings'

let isActive = eval(Cookies.get(Settings.cookies.sound))
if(isActive === undefined)
  isActive = true

export default {
  name: 'Sound',
  beforeDestroy() {
    this.$sound.unload()
  },
  data: () => ({
    active: isActive,
    // ambianceName: 'ambiance-musee-before-secret',
    ambianceName: 'silence',
    ambianceID: null,
    ambianceVolume: .1
  }),
  beforeCreate() {
    this.$sound = new Howl({
      src: [require('./audio/sound_2.mp3')],
      sprite: spriteJSON.sprite,
      loop: true
    })

    this.$ambiance = new Howl({
      src: [require('./audio/ambiance.mp3')],
      sprite: ambianceJSON.sprite
    })

    Howler.mute(isActive ? false : true)
  },
  computed: {
    sound() { return this.$store.getters['app/sound'] },
    ambiance() { return this.$store.getters['app/ambiance'] },
    video_is_playing() { return this.$store.getters['app/video_is_playing'] },
  },
  watch: {
    ambianceName: {
      immediate: true,
      handler() {
        this.ambianceID = this.$sound.play(this.ambianceName)
        this.$sound.volume(this.ambianceVolume, this.ambianceID)
      }
    },
    ambianceID: {
      immediate: true,
      handler(newID, oldID) {
        if(oldID) {
          this.$sound.fade(this.ambianceVolume, 0, 1000, oldID)
          this.$sound.once('fade', () => this.$sound.stop(oldID), oldID)
        }

        this.$sound.fade(0, this.ambianceVolume, 1000, newID)
      }
    },
    active() {
      Howler.mute(this.active ? false : true)
      Cookies.set(Settings.cookies.sound, this.active)
    },
    sound() {
      if(this.sound) {
        const id = this.$sound.play(this.sound)
        this.$sound.once('end', () => this.$store.commit('app/SET_SOUND', null), id)
      }
    },
    ambiance() {
      if(this.ambiance) {
        const id = this.$ambiance.play(this.ambiance)
        this.$ambiance.once('end', () => this.$store.commit('app/SET_AMBIANCE', null), id)
        if(this.ambiance == 'enki' || this.slugIsIn(['defi3']))
          this.$ambiance.volume(0.25, id)
        else
          this.$ambiance.volume(1, id)
      }
    },

    video_is_playing(nw, od) {
      if(!nw)
        this.$sound.volume(this.ambianceVolume, this.ambianceID)
      else 
        this.$sound.volume(0, this.ambianceID)
    },

    '$route': {
      immediate: true,
      handler() {

        if(this.slugIsIn(['introduction']))
          this.$store.commit('app/SET_AMBIANCE', 'enki')

        if(this.slugIsAfter('35') || this.$route.meta.name == 'artwork') {
          if(this.ambianceName != 'alls') {
            this.$sound.stop()
            this.ambianceVolume = .05
            TweenMax.delayedCall(5, ()=> this.ambianceName = 'alls')
          }
        }
      }
    }
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Sound
  position fixed
  top 25px
  right 25px
  cursor pointer
  z-index 99999
  width 20px
  height 20px
  &.is-active
    .Sound__svg-wave
      opacity 1

  &__ico
    .Sound__svg-wave
      opacity 0
    svg
      fill white

</style>



// WEBPACK FOOTER //
// src/components/sound/Sound.vue